import { FullPost, isDefined } from 'model';
import { BaseApi } from './BaseAPI';
import { amendQueryEventDate } from './PostApi';

export type FeedProvideType = 'Post' | 'Community Question' | 'Event' | 'Business Post' | 'Business Check In';

export const FeedApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		getFeed: builder.query<FullPost[], void>({
			query: () => ({
				url: `feed/`
			}),
			transformResponse: (response: FullPost[]) => {
				return response.map(post => amendQueryEventDate(post));
			},
			providesTags: results => {
				const res = [
					{ type: 'Post' } as { type: 'Post' },
					...(results ?? []).filter(isDefined).map(
						({ _id }) =>
							({
								type: 'Post',
								id: _id
							} as { type: 'Post'; id: string })
					)
				];
				return res;
			}
		})
	})
});

export const { useGetFeedQuery } = FeedApi;
